<template>
    <div class="app-het">
      <div v-if="debug_show_page_name==true" style="color:green;">page_0010_device_embedded_information_detail_bulk_edit</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="機器・組込情報(一括編集）" >

          </title-and-slot>

          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
              <button class="btn btn-primary" style="min-width:100px;width: 25%;float: left;margin-left: 10px;" @click="backToList" >＜　戻る</button>
            </div>
            <div class="col-xs-8">
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            状態:
            <select 
            :disabled="readOnly"
            :value="Status"
            @change="Status =$event.target.value"
            style=" border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" >
            <option v-for="option in StatusOptions" :selected="option==Status" :key="option" :value="option">{{option}}</option>
            </select>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A<br> -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-8" style="">
              <div class="row">
                <div class="col-xs-6" style="">
                  <!-- Coll B <br> -->
                  <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
                <div class="col-xs-6" style="">
                  <!-- Coll C<br> -->
                  <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" style="">
                  <field-box   v-for="f in formFields.col2b"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
              </div>
            </div>
          </div>
          <div>
              <button v-show="showApplyButton == true" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="onConfirmExecuteProcess" >申請</button>
              <button v-if="read_only == false" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #337ab7;background: #337ab7;" @click="onLocalSaveBulkDevEmbedded" >下書保存</button>
              <button v-else class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;" @click="onEdit" >編集</button>
          </div>

        </div>
        <device-embedded-information-confirmation-modal tag="showBulkImportConfimationModal" />
        <confirmation-modal tag="confirmBulkDeviceEmbeddedInformationAddCheck" @done="onBulkDeviceEmbeddedInformationAddCheckConfirm" />
        <application-confirmation-modal tag="bulkDeviceEmbeddedApplicationConfimationModal" />
        <confirmation-modal tag="showConfimationModalSetdevice" @done="confirmedSetdevice"></confirmation-modal>
        <device-modal tag="showdeviceModal" @selected="ondeviceModalSelected"></device-modal>
     </div>
</template>

<script>
//FIXME: This page can be merged into page_0010_device_embedded_information_detail.vue, but it can be in a second step.
import deviceembeddedinformationaddcheck from '@/components/modals/device-embedded-information-add_check';
import subTable from '@/components/sub_pages/device-embedded-detail';
import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import bulkImportConfirmationModal from "@/components/modals/device-embedded-information-confirmation-modal";
import applicationConfirmationModal from '@/components/modals/application-confirmation-modal';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import constants from "@/rules/constants";
import deviceModal from "@/components/modals/device-modal";
Vue.component("device-modal", deviceModal);

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'sub-table': subTable,
    "device-embedded-information-confirmation-modal" :bulkImportConfirmationModal,
    'device-embedded-information-bach-edit-modal' : deviceembeddedinformationaddcheck,
    'application-confirmation-modal':applicationConfirmationModal
  },
  data() {
    return {
      api_name:"device_embedded_information",
      page_acl: acl.generic,
      approval_history_id:"",
      local_status:false,
      show_apply_button:false,
      approval_id:null
    };
  },
  computed: {
    showApplyButton:{
      get(){
        return this.show_apply_button;
      },
      set(v){
        this.show_apply_button = v;
      }
    },
    // showMyButton (){
    //   return (this.isAdmin) && this.loadBy == 'ref_id';
    // },
    aprovalId:{
      get(){
        return this.aproval_id;
      },
      set(v){
        this.aproval_id = v;
      }
    },
    approvalHistoryId:{
      get(){
        return this.approval_history_id;
      },
      set(v){
        this.approval_history_id = v;
      }
    },
    Status:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        }else{
          return this.local_status;
        }
      },
      set(v){
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions(){
      var temp = fields.status.options;
      // if(temp.indexOf("") < 0){
      //   temp.push("")
      // }
      return temp;
    },
    deviceControlNumber(){
      return this.$store.state[this.stateCurrentRow]["device_control_number"]
    },
    registrationDate(){
      return  utils.format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(_.clone(fields.device_control_number), { disabled: true , read_only:true}),
          utils.extend(_.clone(fields.virtual_environment), {
            error_if_blank:false,
            on_set_value:(data) =>{
              setTimeout(() => {
                bus.$emit("upd_virtual_base_unit",{val: data == "有"})
              }, 100);
            }
          }),
          utils.extend(_.clone(fields.virtual_base_unit), {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            buttons: [
              {
                  btn_style:"width:100%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 10px;background: #43c9de;border-color:#43c9de;",
                  type:"callback",
                  callback:(b)=>{
                    this.devicePopUp()
                  },
                  label:"機器"// Need the spec.
              }
          ],
            listen_for: [
              {
                name: "upd_virtual_base_unit",
                mode: "disable_if_value",
                disable_if_value: true
              }
            ],
          }),
          utils.extend(_.clone(fields.company), {error_if_blank:false,}),
          utils.extend(_.clone(fields.equipment_in_charge_department), {error_if_blank:false,}),
          utils.extend(_.clone(fields.equipment_in_charge_team), {error_if_blank:false,}),
          utils.extend(_.clone(fields.equipment_in_charge_classification), {
            error_if_blank:false,
            on_set_value:(data) =>{
              setTimeout(() => {
                if(data == "IT所管システム"){
                  bus.$emit("upd_license_jurisdiction_system_it_bulk",{val: true})
                  bus.$emit("upd_license_jurisdiction_system_bulk",{val: false})
                }else if(data == "EUC・その他"){
                  bus.$emit("upd_license_jurisdiction_system_bulk",{val: true})
                  bus.$emit("upd_license_jurisdiction_system_it_bulk",{val: false})
                }else{
                }
              }, 300);
            }
          }),
          utils.extend(_.clone(fields.equipment_in_charge_system_it), {
            error_if_blank:true,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "upd_license_jurisdiction_system_it_bulk",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
          utils.extend(_.clone(fields.equipment_in_charge_system), {
            error_if_blank:false,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "upd_license_jurisdiction_system_bulk",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
        ],
        col2:[
          utils.extend(_.clone(fields.computer_name), {error_if_blank:false,}),
          utils.extend(_.clone(fields.leasing_or_rental), {error_if_blank:false,}),
          utils.extend(_.clone(fields.manufacture_name), {error_if_blank:false,}),
          utils.extend(_.clone(fields.model_name), {error_if_blank:false,}),
          utils.extend(_.clone(fields.equipment_classification), {error_if_blank:false,}),
          utils.extend(_.clone(fields.cpu_count), {error_if_blank:false,})
        ],
        col3:[
          utils.extend(_.clone(fields.installation_department), {default_from_local_storage:false,error_if_blank:false,}),
          utils.extend(_.clone(fields.installation_team), {default_from_local_storage:false,error_if_blank:false,}),
          utils.extend(_.clone(fields.installation_base), {error_if_blank:false,}),
          utils.extend(_.clone(fields.floor), {}),
          utils.extend(_.clone(fields.user_name), {error_if_blank:false,}),
          utils.extend(_.clone(fields.management_person_name), {error_if_blank:false,})

        ],
        col2b:[
          utils.extend(_.clone(fields.remarks), {})
        ],
      }
    },
    loadBy(){
      return this.$route.meta.load_by;
    }
  },
  methods: {
    processFieldStyle(store_key_name,last_changed_fields){
      this.$store.state[store_key_name] = {};
      if(last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0 ){
        last_changed_fields.forEach(f=>{
          if(this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" && this.showProcessAprovalButton){
            this.$store.state[store_key_name][f] = ";color:red;"
          }
        });
      }
    },
    processApproval(){
      var changes = {
        seq_id:this.aprovalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
      }
      this.$ajax.post('/approval_history/prepare_to_approve/' + this.aprovalId, {changes}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの承認に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            return this.$router.push("/approval_history");
          }
        })
    },
    onBulkDeviceEmbeddedInformationAddCheckConfirm(mode){
      if(mode == "yes"){
        this.read_only = false;
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
        try {
          list_seq_id = JSON.parse(list_seq_id)
          var disabled_fields = []
          this.allFields.forEach(f=>{
            if(f.ref_field && ((f.ref_field.data && f.ref_field.data.disabled == true)  || (f.ref_field.localDisabled == true))){
              disabled_fields.push(f.id)
            }
          })
          this.saveBulk(this.api_name,list_seq_id.arr, { from_edit_form: true,disabled_fields }, (err)=>{
            this.showApplyButton = true;
            this.read_only = true;
            //Bellow code will copy the data  from stateCurrentEditing to stateCurrentRow
            setTimeout(() => {
              var temp_current = _.clone(this.$store.state[this.stateCurrentRow])
              var temp = _.clone(this.$store.state[this.stateCurrentEditing])
              this.allFields.forEach(f=>{
                if(typeof temp[f.id] == "undefined" ){
                  temp[f.id] = temp_current[f.id] || "";
                }
              })
              this.$store.state[this.stateCurrentRow] = temp
              this.$store.state[this.stateCurrentEditing] = temp
            }, 50);
          })
        } catch (error) {
          this.$notify({
            title: "予期しないエラーが発生し、登録が行えません",
            text:error,
            type: 'error',
            duration: 12000
          })
        }
      }
    },
    onConfirmExecuteProcess(){
      var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id)
        var syubetu = constants.SYUBETU.DEVICE
        bus.$emit("bulkDeviceEmbeddedApplicationConfimationModal",{
          list_seq_id:list_seq_id.arr,
          application_mode:"bulk_edit_device_embedded",
          title_suffix:""+syubetu+"(一括編集）",
          process_import_url:'/' + this.api_name + '/bulk_to_approval_history/',
          on_finish_url_name:"page_0010_device_embedded_information",
          ref_id:null,
        });
      } catch (error) {
        this.$notify({
          title: "適用する行の読込に失敗しました。",
          text:error,
          type: 'error',
          duration: 12000
        })
      }
    },
    onLocalSaveBulkDevEmbedded(){
      console.log("onLocalSave")
      this.commonValidateFields(this,{},(error_found)=>{
        if(error_found != false){
          return;
        }
        bus.$emit("confirmBulkDeviceEmbeddedInformationAddCheck",{
          message: "",
          title: "本当に登録してよろしいでしょうか。",
          yes_label: "完了",
          no_label: "キャンセル",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
      })
    },
    onEdit(){
      mdebug("onEdit")
      setTimeout(() => {
        this.showApplyButton = false;
        this.read_only = false;
      }, 300);
    },
    btnCancel() {
          this.cancelCurrentSelection(true);
        },
    backToList(){
      Vue.localStorage.remove('bulk_edit_' + this.local_page_id);
      var device_back_to_list = window.sessionStorage.getItem("device_back_to_list")
      if((device_back_to_list||"").indexOf("/")==0){
        return this.$router.push(device_back_to_list);
      }else{
        return this.$router.push("/device_embedded_information");
      }
    },
    gotocertificate(){
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate(){
      this.showSubTable = true;
    },
    confirmedSetdevice(mode){
      if(mode == "yes"){
         bus.$emit("device_number_force_update",this.temp_device_management_number );
      }else if(mode == "no"){
          return bus.$emit("showdeviceModal");
      }
    },
    devicePopUp(){
      bus.$emit("showdeviceModal");
    },
    ondeviceModalSelected(val){
      if(val && val.length > 0){
          bus.$emit("showConfimationModalSetdevice", {
                title:"",
                message:"管理番号 '"+val+"' を割り当てます。よろしいですか？",
                yes_label:"OK",
                no_label:"戻る",
                yes_color:"primary",
                model_height:80
              })
        this.temp_device_management_number = val;
      }
    },
     prepareCompanySelection(companies, department_and_team, company_field, department_field,team_field,company_field_name,department_field_name){
      var selected_company = false;
      var selected_department = false
      company_field.page_controller_setup({
        on_select:(_selected_company)=>{
          selected_company = _selected_company;
          if(selected_company==""){
            department_field.page_controller_msg({cmd:"disable"})
            team_field.page_controller_msg({cmd:"disable"})
          }else{
            var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
            departments.unshift("")
            department_field.page_controller_msg({cmd:"enable"})
            department_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({cmd:"disable"})
            department_field.page_controller_msg({cmd:"set_options",options:departments, reset:true})
          }
        }
      })
      department_field.page_controller_setup({
        on_select:(_selected_department)=>{
          selected_department = _selected_department;
          if(selected_department == ""){
            team_field.page_controller_msg({cmd:"disable"})
            team_field.page_controller_msg({cmd:"set_value",val:""})
          }else{
            var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company && d.department == selected_department})||[],"team")||[]);
            teams.unshift("");
            team_field.page_controller_msg({cmd:"enable"})
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({cmd:"set_options",options:teams, reset:true})
          }
        }
      })
      company_field.page_controller_msg({cmd:"set_options",options: _.clone(companies)})
      company_field.page_controller_msg({cmd:"disable"})
      department_field.page_controller_msg({cmd:"disable"})
      team_field.page_controller_msg({cmd:"disable"})
      setTimeout(() => {
        department_field.page_controller_msg({cmd:"enable_if_data"})
        team_field.page_controller_msg({cmd:"enable_if_data"})
        selected_company = this.$store.state[this.stateCurrentRow][company_field.id]
        selected_department = this.$store.state[this.stateCurrentRow][department_field.id]
        if(selected_company && selected_company.length > 0){
          department_field.page_controller_msg({ cmd: "enable" });
          var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
          department_field.page_controller_msg({cmd:"set_options",options:departments, reset:false})
          if(selected_department && selected_department.length > 0){
            var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company &&  d.department == selected_department})||[],"team")||[]);
            team_field.page_controller_msg({cmd:"set_options",options:teams, reset:false})
          }
        }
        var slUserCompany = Vue.localStorage.get("userCompany") || false;
        if(slUserCompany && slUserCompany.indexOf("MH") == 0){
          company_field.page_controller_msg({cmd:"set_value",val:slUserCompany})
        }else if(slUserCompany && slUserCompany.indexOf("ライセンス管理窓口") == 0){
          console.log('TEST DEBUG 210429 (410 at page_0010_device_embedded_information_detail_bulk_edit.vue)[16:08]: try to enable', {  });
          company_field.page_controller_msg({cmd:"enable"})
        }

      }, (this.is_new)?100:500);
    },
    startCompanySelection(){
      if(this.company_selection_started == true){
        return;
      }
      this.company_selection_started  = true;
      if(true){
        var temp_fields = this.installedFieldList;
        // Load the companies
        this.$ajax.post_cached_queued('/master_company/list_company_name' , {}, (err, _companies) => {
          if(err){
            this.$notify({
                title: '所管会社のデータが読込めませんでした。',
                text: err,
                type: 'error',
                duration: 10000
              });
            return ;
          }
          var companies = [""]
          _companies.forEach(c=>{
            companies.push(c.val)
          })
          // Load the departments and teams
          this.$ajax.post_cached_queued('/master_belongs/list_team_and_department' , {}, (err, department_and_team) => {
            if(err){
              this.$notify({
                  title: '部署・チームのデータの読込に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              return ;
            }
            this.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.equipment_in_charge_department,temp_fields.equipment_in_charge_team,"company","department")
            if(this.$route.params.seq_id == "new"){
              var default_company = Vue.localStorage.get(temp_fields.company.default_from_local_storage);
              if(default_company != constants.COMPANY.ALL){
                setTimeout(() => {
                  var default_deparment = Vue.localStorage.get(temp_fields.equipment_in_charge_department.default_from_local_storage);
                var default_team = Vue.localStorage.get(temp_fields.equipment_in_charge_team.default_from_local_storage);
                temp_fields.company.page_controller_msg({cmd:"set_value",val:default_company})
                temp_fields.equipment_in_charge_department.page_controller_msg({cmd:"set_value",val:default_deparment})
                temp_fields.equipment_in_charge_team.page_controller_msg({cmd:"set_value",val:default_team})
                }, (this.is_new)?300:1000);
              }
            }
          })
        })
      }
    }

  },
  mounted() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.addHtmlClass(document.body,'blue_bg')
    this.local_page_id = this.$route.params.p_id;

    this.is_new = true;
    // Note, it is not editing a new record, but will emulate it, as the behaivour is the same.
    this.allFields.forEach(f =>{
      this.$store.state[this.stateCurrentRow][f.id] = "";
    })
    this.startCompanySelection();
    setTimeout(() => {
      this.$store.state[this.stateIsEditingNew] = true;
      this.read_only = false;
      this.is_new = true;
      bus.$emit("upd_license_jurisdiction_system_it_bulk",{val: false})
      bus.$emit("upd_license_jurisdiction_system_bulk",{val: false})
    }, 300);
  },
  beforeDestroy() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.removeHtmlClass(document.body,'blue_bg')
  },
  beforeMount() {
  },
   }


</script>
<style scoped>

.bottom_tab  {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input{
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left:4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0010_device_embedded_information_detail_bulk_edit.vue?34de5a39